const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class AIService {
  // Get auth token from localStorage
  getAuthToken() {
    return localStorage.getItem('token');
  }

  // Build headers with auth token
  getHeaders() {
    const token = this.getAuthToken();
    return {
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json'
    };
  }

  // Analyze CV recommendation for a specific job
  async analyzeCVRecommendation(jobId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/ai/analyze/cv-recommendation/${jobId}`, {
        method: 'POST',
        headers: this.getHeaders()
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Analysis failed: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error analyzing CV recommendation:', error);
      throw error;
    }
  }
}

export const aiService = new AIService(); 